import type { ReactNode } from "react";
import { Inbox } from "lucide-react";
import { IntentButton } from "./intent-button";

export interface EmptyStateProps {
  /**
   * Decorative icon shown above the headline. The icon slot is wrapped in
   * `aria-hidden`, so its content is invisible to assistive technology —
   * pass decorative content only.
   */
  icon?: ReactNode;
  headline: string;
  description?: string;
  cta?: { label: string; onClick: () => void };
}

export function EmptyState({ icon, headline, description, cta }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-12 text-center">
      <div aria-hidden className="text-muted-foreground">
        {icon ?? <Inbox className="size-10" />}
      </div>
      <h3 className="text-lg font-semibold">{headline}</h3>
      {description ? <p className="max-w-md text-sm text-muted-foreground">{description}</p> : null}
      {cta ? <IntentButton onClick={cta.onClick}>{cta.label}</IntentButton> : null}
    </div>
  );
}
